import {forwardRef, ComponentProps} from 'react';
import {Button, IconButton, ListItemButton} from '@mui/material';
import {useAccountDeletion} from '../../../models/AccountDeletion';

// Explicitly mark controls that change data. Navigation, search, downloads and closing
// dialogs use the regular MUI controls and remain usable.
export const WriteButton = forwardRef<HTMLButtonElement, ComponentProps<typeof Button>>((props, ref) => {
    const {isReadOnly} = useAccountDeletion();
    return <Button {...props} ref={ref} disabled={isReadOnly || props.disabled}/>;
}) as typeof Button;
export const WriteIconButton = forwardRef<HTMLButtonElement, ComponentProps<typeof IconButton>>((props, ref) => {
    const {isReadOnly} = useAccountDeletion();
    return <IconButton {...props} ref={ref} disabled={isReadOnly || props.disabled}/>;
}) as typeof IconButton;
export const WriteListItemButton = forwardRef<HTMLDivElement, ComponentProps<typeof ListItemButton>>((props, ref) => {
    const {isReadOnly} = useAccountDeletion();
    return <ListItemButton {...props} ref={ref} disabled={isReadOnly || props.disabled}/>;
}) as typeof ListItemButton;
export function WriteFileInput(props: ComponentProps<'input'>) {
    const {isReadOnly} = useAccountDeletion();
    return <input {...props} disabled={isReadOnly || props.disabled}/>;
}
